/**
 * Project Status Badge Component
 */

import { Badge } from '@/components/ui/badge';
import type { ProjectStatus } from '../types';

const STATUS_CONFIG: Record<ProjectStatus, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning' }> = {
  confirmed: { label: 'Confirmed', variant: 'default' },
  scheduled: { label: 'Scheduled', variant: 'warning' },
  invoiced: { label: 'Invoiced', variant: 'success' },
  sent_to_lab: { label: 'Sent to Lab', variant: 'warning' },
  shipped: { label: 'Shipped', variant: 'default' },
  delivered: { label: 'Delivered', variant: 'success' },
  roadblock: { label: 'Roadblock', variant: 'destructive' },
};

interface ProjectStatusBadgeProps {
  status: ProjectStatus;
  className?: string;
}

export function ProjectStatusBadge({ status, className }: ProjectStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || { label: status, variant: 'secondary' as const };

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
